/* Which environment is this build running in?
 *
 * Decided from the hostname at runtime, not from a build-time variable, so
 * that one build artifact still runs in all three environments -- which is why
 * the API is called on a relative path. A per-environment build would be a
 * second thing to keep in step, and the one that got it wrong would be the one
 * that looked like production.
 *
 * Production is the only hostname treated as production. Anything else --
 * dev, localhost, an IP, a hostname nobody has thought of yet -- gets the
 * testing warning. An unfamiliar host showing a warning it did not need is a
 * nuisance; the real till quietly passing for a test system is not. */

const PRODUCTION_HOST = "pos.namjing.xyz";

export const PRODUCTION_URL = `https://${PRODUCTION_HOST}`;

export const isTestEnvironment = () =>
    window.location.hostname !== PRODUCTION_HOST;
